import { useSelectedCandidateBatchStatusesHandler } from './useSelectedCandidateBatchStatusesHandler';

export const checkCampaignIsForAnalysis = (
  selectedCandidateBatchStatuses: string[] | null | undefined
): boolean => {
  if (!selectedCandidateBatchStatuses) {
    return false;
  }

  return selectedCandidateBatchStatuses.length > 0;
};

export const useCheckCampaignIsForAnalysis = () => {
  const { candidateBatchStatuses } = useSelectedCandidateBatchStatusesHandler();

  return {
    isCampaignForAnalysis: checkCampaignIsForAnalysis(candidateBatchStatuses)
  };
};
